export default __webpack_public_path__ + "static/media/Gaskets.43e7420d.jpg";